import * as React from 'react';
import * as styles from './CommandBar.css'

export interface IProps {
  highlightColor?: string;
  leftSideContent?: JSX.Element;
  rightSideContent?: JSX.Element;
  backgroundColor?: string;
  showBar?: boolean;
  style?: React.CSSProperties;
}

export interface IState {
}

export class IACommandBar extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_commandBar}
        style={{
          backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : "transparent",
          display: !this.props.showBar ? 'none' : '',
          ...this.props.style
        }}
      >
        <div className={styles.leftSideContent}>
          {this.props.leftSideContent}
        </div>
        <div className={styles.rightSideContent}>
          {this.props.rightSideContent}
        </div>
      </div>
    );
  }
}